<mat-card *ngIf="childTreatments?.length || parentTreatment">
	<mat-card-content>
		<h3>
			<i class="fas fa-diagram-project"></i>
			{{"AssociatedTreatmentsHeader" | translate}}
		</h3>
		<div *ngIf="childTreatments?.length" class="child-treatments">
			<div *ngFor="let item of childTreatments; trackBy: trackByFn">
				<button mat-raised-button (click)="goToTreatment(item)">
					<i class="fal fa-diagram-next"></i>
					{{'GoToChildTreatment' | translate}}
				</button>
			</div>
		</div>
		<button mat-raised-button *ngIf="parentTreatment" (click)="goToTreatment(parentTreatment)">
			<i class="fal fa-diagram-previous"></i>
			{{'GoToParentTreatment' | translate}}
		</button>
	</mat-card-content>
</mat-card>
